module.exports = __webpack_public_path__ + "static/laura_02-66edc6d77ee3f52d67f602becdaf0dc5.jpg";